<template>
  <div class="pages">
    <!--顶部头像-->
    <div class="headerInfo">
      <img class="headBack" src="../static/images/main/banner_null.png" width="100%"/>
      <div class="backView">
        <span class="Back" @click="back()">返回</span>
      </div>
      <div class="userInfo">
        <img v-if="user.Sex == '男'" :src="user.Head != ''?user.Head:headImgUrl" class="round_icon"
             :style="{border:'solid 2px #AACC03'}">
        <img v-if="user.Sex == '女'" :src="user.Head != ''?user.Head:headImgUrl" class="round_icon"
             :style="{border:'solid 2px #E75296'}">
        <span>{{ user.Name }}</span>
      </div>
    </div>
    <div class="info">
      <ul>
        <li>
          <em>{{ user.Height }}</em>
          <span>身高cm</span>
        </li>
        <li>
          <em>{{ user.Age }}</em>
          <span>年龄</span>
        </li>
        <li>
          <em>{{ user.Weight }}</em>
          <span>体重kg</span>
        </li>
        <li>
          <em>{{ user.Sex }}</em>
          <span>性别</span>
        </li>
      </ul>
    </div>

    <div class="fitnessRecord">
      <div class="title">
        充值记录
      </div>
      <ul class="recordEmpty" v-if="chargeList.length <1">
        没有查到充值记录噢 . . .
      </ul>

      <ul class="record" v-if="chargeList.length >0">
        <li v-for="(item,index) in chargeList">
          <div class="divIndex">{{ index + 1 }}</div>
          <div class="divContent">
            <div class="rowTitle">
              <span>英泓小飞龙</span>（{{ item.ShopName.length > 7 ? item.ShopName.slice(5) : item.ShopName.slice(3) }}）
              <em>{{ item.ChargeTime |filterTime }}</em>
            </div>
            <div class="rowContent">
              <div class="columnDetail">
                <div class="detailLeft">
                  <div class="leftRow_1">
                    <i style="background: #F9C8DF"/>
                    会籍：{{ item.ChargeNormalMonth }}个月
                    <em v-if="item.ChargeGiftMonth > 0">赠送{{ item.ChargeGiftMonth }}个月</em>
                    <em v-else>无赠送</em>
                  </div>
                  <div class="leftRow_1">
                    <i style="background: #B9E5FF"/>
                    课时：{{ item.ChargeNormalClassHour }}课时
                    <em v-if="item.ChargeGiftClassHour > 0">赠送{{ item.ChargeGiftClassHour }}课时</em>
                    <em v-else>无赠送</em>
                  </div>
                </div>
                <div class="detailRight">
                  <em>￥</em>
                  {{ item.TotalFee / 100 }}
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!--底部课程统计-->
    <bottomTab :curTab="thisTab"/>
  </div>
</template>

<script>
import axios from 'axios';
import bottomTab from '../components/bottomTab'
import {
  VipUserSelfQuery,
  MyChargeInfoListQuery,
} from '../api/getApiRes.js'

let qs = require('qs');
import Global from '../Global.js'
// 引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')
// 引入提示框和title组件
require('echarts/lib/component/title')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/dataZoom')
require('echarts/lib/component/legend')
require('echarts/lib/component/grid')

export default {
  data() {
    return {
      DuId: '',
      ShopId:'',
      userMd5: '',
      thisTab: '我的运动',
      screenWidth: document.body.clientWidth + 'px',
      headImgUrl: require('../static/images/mine/header_default.png'),
      chargeList: {},//体测数据集
      user: {
        Name: '',
        Age: '',
        Height: '',
        Weight: '',
        StaticHr: '',
        Phone: '',
        Sex: '',
        Head: '',
      }
    }
  },
  watch: {
    '$route'(to) {
      if (to.name == 'fitnessRecord') {
        let that = this;
        that.getUserInfo();//获取用户基本信息
        that.getChargeRecord();//获取测评记录
      }
    },
  },
  mounted() {
    let that = this;
    that.ShopId =  this.$route.query.shopId;
    that.getUserInfo();//获取用户基本信息
    that.getChargeRecord();//获取测评记录
  },
  methods: {
    //返回上一页
    back() {
      this.$router.push({path: '/report'});
    },
    //获取用户基本信息
    getUserInfo() {
      let that = this;
      let param = {
        token: localStorage.token
      };
      let postData = qs.stringify(param);
      VipUserSelfQuery(postData).then(res => {
        let json = res;
        if (json.Code == 0) {
          that.user = json.Rs;
          that.userMd5 = json.Rs.UserMd5;
        } else {
          that.$toast.message(json.Memo);
        }
      })
    },
    //获取充值记录
    getChargeRecord() {
      let that = this;
      let param = {
        token: localStorage.token,
        shopId:that.ShopId
      };
      let postData = qs.stringify(param);
      MyChargeInfoListQuery(postData).then(res => {
        let json = res;
        if (json.Code == 0) {
          that.chargeList = json.Rs;
        } else {
          that.chargeList = [];
        }
      })
    },
  },
  filters: {
    hidePhone: function (val) {
      let str = String(val)
      let len = str.length;
      if (len >= 7) {
        let reg = str.slice(-8, -4)
        return str.replace(reg, "****")
      } else if (len < 7 && len >= 6) {
        let reg = str.slice(-4, -2)
        return str.replace(reg, "**")
      }
    },
    filterTime: function (value) {
      if (!value) {
        return 0;
      } else {
        return dateFormatWithoutZone(value, 16);
      }
    },
    fmtTime: function (value) {
      if (!value) {
        return 0
      } else {
        // js默认使用毫秒
        value = value * 1000
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    // A跳转到B，B页面停留在A页面的滚动位置；解决方法：将scrollTop设置为0
    next(vm => {
      //因为当钩子执行前，组件实例还没被创建
      // vm 就是当前组件的实例相当于上面的 this，所以在 next 方法里你就可以把 vm 当 this 来用了。
      if (to.name == 'reportLessonDetail') {
        vm.getUserInfo();
      }
    });
  },
  components: {
    bottomTab
  }
}
</script>

<style scoped>
.pages {
  display: block;
  margin: 0 auto;
  background: #F2F2F2;
  overflow: scroll;
  height: 100vh;
  padding-bottom: 80px;
}

.headerInfo {
  position: relative;
}

.headerInfo .headBack {
  height: 120px;
  position: absolute;
  z-index: 1;
}

.headerInfo .backView {
  left: 5%;
  top: 1.5rem;
  position: absolute;
  z-index: 2;
  text-align: center;
}

.headerInfo .Back {
  width: 50px;
  height: 25px;
  font-size: 14px;
  border-radius: 2px;
  line-height: 26px;
  color: #F4F4F4;
  display: block;
  margin-top: 60px;
  margin-left: -10px;
  background: rgba(255, 255, 255, 0.24);
  text-align: center;
}


.headerInfo .userInfo {
  left: 42%;
  top: 1.25rem;
  position: absolute;
  z-index: 2;
  text-align: center;
}

.headerInfo .userInfo span {
  font-size: 16px;
  color: white;
  display: block;
  margin-top: 5px;
}

.round_icon {
  width: 64px;
  height: 64px;
  display: flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-bottom: 3px;
  border: solid 2px white;
}

.info {
  background: #fff;
  width: 100%;
  overflow: hidden;
  display: block;
  margin: 120px auto 0;
}

.info ul {
  width: 100%;
  overflow: hidden;
  display: block;
  margin: 10px auto;
}

.info li {
  width: 25%;
  border-left: 1px solid #fff;
  border-right: 1px solid #fff;
  float: left;
  text-align: center;
}

.info li:nth-child(2) {
  border-color: #e2e2e2;
}

.info li:nth-child(3) {
  border-color: #e2e2e2;
  border-left: 0;
}

.info li em {
  width: 100%;
  overflow: hidden;
  display: block;
  margin: 0 auto;
  color: #363636;
  font-size: 20px;
  text-align: center;
}

.info li span {
  width: 100%;
  overflow: hidden;
  display: block;
  margin: 0 auto;
  color: #c4c4c4;
  font-size: 12px;
  text-align: center;
}

.fitnessRecord {
  overflow: auto;
  margin-top: 10px;
}

.fitnessRecord .title {
  height: 60px;
  font-size: 16px;
  color: #FFA310;
  font-weight: bold;
  line-height: 60px;
  text-align: center;
  background: #FFFFFF;
}

.fitnessRecord .recordEmpty {
  height: 200px;
  line-height: 100px;
  text-align: center;
  font-weight: normal;
  font-size: 16px;
}

.fitnessRecord .record {
  margin-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.fitnessRecord .record li {
  background: #FFFFFF;
  height: 85px;
  width: 95%;
  margin: 20px auto 0;
  border-radius: 8px;
}

.fitnessRecord .record li .divIndex {
  line-height: 85px;
  font-size: 24px;
  color: white;
  width: 34px;
  height: 100%;
  border-radius: 8px 0 0 8px;
  background: #FFA310;
  text-align: center;
  float: left;
}

.fitnessRecord .record li .divContent {
  height: 100%;
}

.divContent .rowTitle {
  font-size: 14px;
  color: #363636;
  height: 35px;
  line-height: 35px;
}

.divContent .rowTitle span {
  font-size: 16px;
  margin-left: 15px;
  color: #363636;
}

.divContent .rowTitle em {
  float: right;
  font-size: 14px;
  margin-right: 20px;
  color: #C9C9C9;
}

.divContent .rowContent {
  height: 50px;
  margin-left: 35px;
}

.rowContent .columnDetail {
  height: 100%;
}

.columnDetail .detailLeft {
  color: #909090;
  float: left;
  height: 50px;
  line-height: 23px;
}

.columnDetail .detailLeft i {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 250px;
  background: #e75296;
  margin-bottom: 2px;
  margin-right: 5px;
  margin-left: 15px;
}

.columnDetail .detailLeft em {
  color: #C9C9C9;
  font-size: 12px;

}

.columnDetail .detailRight {
  float: right;
  height: 45px;
  margin-right: 20px;
  line-height: 45px;
  font-size: 24px;
  color: #FF5800;
}

.columnDetail .detailRight em {
  font-size: 20px;
  margin-right: -5px;
}

/deep/ .mu-warning-text-color {
  float: left;
}

@media only screen and (max-width: 640px) {

}

@media only screen and (max-width: 480px) {

}

@media only screen and (max-width: 375px) {
}

@media only screen and (max-width: 360px) {
}

@media only screen and (max-width: 320px) {

}

@media only screen and (min-width: 641px) {

}
</style>
